import Footer from "./footer/footer";
import Header from "./header/header";
import footerClasses from "./footer/footer.module.scss";
import headerClasses from "./header/header.module.scss";

export { footerClasses, headerClasses, Header, Footer };